import { Component, OnInit } from "@angular/core";
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { Store } from "@ngrx/store";
import { State } from "../../app-store";
import { getCurrentUser, ICurrentUser } from "../../app-store/current-user";
import { UtilitiesService } from "../services/utilities.service";
import { DataService } from "../services/dataservice";
import { IUser } from "../models/interfaces/user";

@Component({
  selector: "app-navigation-bar",
  templateUrl: "./navigation-bar.component.html",
  styleUrls: ["./navigation-bar.component.scss"]
})
export class NavigationBarComponent implements OnInit {
  isAdminUser = false;
  loggedInUser: IUser | undefined;
  currentUser: ICurrentUser | null;

  constructor(
    private utilitiesService: UtilitiesService,
    private msalBroadcastService: MsalBroadcastService,
    private authService: MsalService, 
    private dataService: DataService,
    private store: Store<State>
  ) {}

  ngOnInit() {
    this.checkoutAccount();
    this.checkAndSetIntAccount();
   }

   checkAndSetIntAccount() {
    //console.log("navbar - checkAndSetIntAct");
    let activeAccount = this.authService.instance.getActiveAccount();
    if(activeAccount){
       this.currentLoggedUserInStore(activeAccount!.username);
    }
    else{
      this.currentUserInStore();
    }
  }
   currentLoggedUserInStore(userName: string) {
     this.store.select(getCurrentUser).subscribe((currentUser) => {
          this.currentUser = currentUser;

          if(currentUser && currentUser.dbUser && currentUser.userName === userName) {
            this.loggedInUser = currentUser.dbUser;
          }
    });
   }

   currentUserInStore() {
     this.store.select(getCurrentUser).subscribe((currentUser) => {
          this.currentUser = currentUser;
     });
   }

   checkoutAccount() {
    this.utilitiesService.isCurrentUserAdmin().subscribe((status) => {
      this.isAdminUser = status;
      //console.log("NavBar -  admin user Status - ", status);
    });
   }
}
